import {DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {TranslateModule} from '@ngx-translate/core';
import {IconButtonComponent} from '@q9elements/ui-kit/components';

import {ItemsSelectorComponent} from './components/items-selector.component';
import {GetDisplayValuePipe} from './pipes/get-display-value.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    DragDropModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    IconButtonComponent
  ],
  declarations: [ItemsSelectorComponent, GetDisplayValuePipe],
  exports: [ItemsSelectorComponent]
})
export class ItemsSelectorModule {}

export {ItemsSelectorComponent};
